import { Grid } from 'semantic-ui-react';

const VoiceDetailDisplay = ({ voiceDetailObj, charSpeechData, promptWidth = 5 }) => {
  let validRows = [];
  let keyIdx = 0
  if (voiceDetailObj?.litGroupItem.name) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad noLeftPad" width={promptWidth} textAlign='right'>Literary Group:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{voiceDetailObj?.litGroupItem.name}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  if (voiceDetailObj?.bookItem.name) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad" width={promptWidth} textAlign='right'>Book:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{voiceDetailObj?.bookItem.name}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  if (voiceDetailObj?.characterItem.name) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad" width={promptWidth} textAlign='right'>Character:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{voiceDetailObj?.characterItem.name}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  if (charSpeechData?.character?.speechSample?.title) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad" width={promptWidth} textAlign='right'>Description:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{charSpeechData?.character?.speechSample?.title}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  if (charSpeechData?.character?.voiceSnippet?.fileName) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad" width={promptWidth} textAlign='right'>Voice Filename:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{charSpeechData?.character?.voiceSnippet?.fileName}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  if (charSpeechData?.character?.speechSample?.revision) {
    validRows.push(<Grid.Row className="noMargNoPad" key={"r" + keyIdx.toString()}>
      <Grid.Column className="noRightPad" width={promptWidth} textAlign='right'>Revision:</Grid.Column>
      <Grid.Column width={11} key={keyIdx.toString()}>{charSpeechData?.character?.speechSample?.revision}</Grid.Column> </ Grid.Row >)
    keyIdx++;
  }
  return (

    <Grid style={{ width: "400px" }}>
      {validRows}
    </Grid>
  )
}

export default VoiceDetailDisplay;
